import gql from "graphql-tag";

export default {
	getUserBookLists: gql`
    query getUserBookLists {
      getMyBookLists {
        id
        _id
        name
        bookListItems {
          id
          productId
        }
      }
    }
  `,

  getAdminBookLists: gql`
    query getAdminBookLists {
      bookLists {
        id
        _id
        name
        customerId
        isPublic
        updatedAt
        forSchool {
          id
          _id
          name
        }
        forB2bCustomer {
          id
          _id
          organizationName
        }
        itemCount
      }
    }
  `,

  getAdminBookListsLegacy: gql`
    query getAdminBookListsLegacy {
      bookLists {
        id
        _id
        name
        customerId
        isPublic
        updatedAt
        forSchool {
          id
          _id
          name
        }
        bookListItems {
          id
        }
      }
    }
  `,

  getPublicBookListBySlug: gql`
    query getPublicBookListBySlug($slug: String!) {
      getPublicBySlugBookLists(slug: $slug) {
        id
        _id
        name
        slug
        isPublic
        allowPublicCart
        discountPercentage
        taxRate {
          id
          rate
        }
        bookListItems {
          id
          productId
          name
          thumbnailUrl
          basePrice
          baseCurrency {
            id
            _id
          }
          quantity
          vatIncluded
          position
          createdAt
          updatedAt
        }
      }
    }
  `,

  getPublicBookListBySlugLegacy: gql`
    query getPublicBookListBySlugLegacy($slug: String!) {
      getPublicBySlugBookLists(slug: $slug) {
        id
        _id
        name
        slug
        isPublic
        discountPercentage
        taxRate {
          id
          rate
        }
        bookListItems {
          id
          productId
          name
          thumbnailUrl
          basePrice
          baseCurrency {
            id
            _id
          }
          quantity
          vatIncluded
          position
          createdAt
          updatedAt
        }
      }
    }
  `,

	addItemToBookList: gql`
    mutation addItemToBookList($input: addItemToBookListInput!) {
      addItemToBookList(input: $input) {
        bookList {
          id
          _id
          name
          bookListItems {
            id
            productId
          }
        }
      }
    }
  `,

	deleteBookListItem: gql`
    mutation deleteBookListItem($id: ID!) {
      deleteBookListItem(input: {id: $id}) {
        bookListItem {
          id
        }
      }
    }
  `,

	deleteBookList: gql`
    mutation deleteBookList($id: ID!) {
      deleteBookList(input: {id: $id}) {
        bookList {
          id
        }
      }
    }
  `,

  setPrivacyBookList: gql`
    mutation setPrivacyBookList($input: setPrivacyBookListInput!) {
      setPrivacyBookList(input: $input) {
        bookList {
          id
          isPublic
          allowPublicCart
          slug
        }
      }
    }
  `,

  setPrivacyBookListLegacy: gql`
    mutation setPrivacyBookListLegacy($input: setPrivacyBookListInput!) {
      setPrivacyBookList(input: $input) {
        bookList {
          id
          isPublic
          slug
        }
      }
    }
  `,

	createBookList: gql`
  mutation createBookList($input: createBookListInput!) {
    createBookList(input: $input) {
      bookList {
        id
        _id
        name
        slug
        isPublic
        notes
        forSchool {
          id
          _id
          name
        }
        forB2bCustomer {
          id
          _id
          organizationName
        }
        discountPercentage
        taxRate {
          id
          _id
          rate
        }
        bookListItems {
          id
          productId
          name
        }
        archivedAt
      }
    }
  }
  `,

	updateBookList: gql`
  mutation updateBookList($input: updateBookListInput!) {
    updateBookList(input: $input) {
      bookList {
        id
        _id
        name
        slug
        isPublic
        allowPublicCart
        notes
        forSchool {
          id
          _id
          name
        }
        forB2bCustomer {
          id
          _id
          organizationName
        }
        discountPercentage
        taxRate {
          id
          _id
          rate
        }
        bookListItems {
          id
          productId
          name
        }
        archivedAt
      }
    }
  }
  `,

	updateBookListLegacy: gql`
  mutation updateBookListLegacy($input: updateBookListInput!) {
    updateBookList(input: $input) {
      bookList {
        id
        _id
        name
        slug
        isPublic
        notes
        forSchool {
          id
          _id
          name
        }
        forB2bCustomer {
          id
          _id
          organizationName
        }
        discountPercentage
        taxRate {
          id
          _id
          rate
        }
        bookListItems {
          id
          productId
          name
        }
        archivedAt
      }
    }
  }
  `,

	duplicateBookList: gql`
  mutation duplicateBookList($input: duplicateBookListInput!) {
    duplicateBookList(input: $input) {
      bookList {
        id
        _id
        name
        slug
        isPublic
        notes
        forSchool {
          id
          _id
          name
        }
        forB2bCustomer {
          id
          _id
          organizationName
        }
        discountPercentage
        taxRate {
          id
          _id
          rate
        }
        bookListItems {
          id
          productId
          name
        }
        archivedAt
      }
    }
  }
  `,
  updateBookListItem: gql`
  mutation updateBookListItem($input: updateBookListItemInput!) {
    updateBookListItem(input: $input) {
      bookListItem {
        id
        quantity
        vatIncluded
        position
      }
    }
  }
  `,
};
